export enum RoleType {
  Trial = 1,
  Premium = 2,
  Admin = 3,
}
